import { mock, Random } from 'mockjs';

const gernerate = (i: number) => {
  let month = Random.date('MM');
  return mock({
    c1: `DICT_${i}`,
    c2: `XXXX字典`,
    'c6|1': ['业务字典', '系统字典'],
    c7: Random.integer(0, 1),
    c8: Random.integer(0, 1),
    c11: Random.cname(),
    c12: '2021-11-30 ' + Random.time(),
    c13: Random.cname(),
    c14: '2021-11-30 ' + Random.time()
  });
};

let d = [];
for (let i = 100; i < 111; i++) {
  d.push(gernerate(i));
}

export const list = d;

export const columns = [
  { title: '字典编码', dataIndex: 'c1', width: 120 },
  { title: '字典名称', dataIndex: 'c2', width: 160 },
  { title: '业务类型', dataIndex: 'c6', width: 120 },
  {
    title: '是否启用',
    dataIndex: 'c7',
    width: 120,
    scopedSlots: {
      customRender: 'c7'
    }
  },
  { title: '创建人', dataIndex: 'c11', width: 100 },
  { title: '创建时间', dataIndex: 'c12', width: 200 },
  { title: '最近操作人', dataIndex: 'c13', width: 120 },
  { title: '最近操作时间', dataIndex: 'c14', width: 200 },
  {
    title: '操作',
    dataIndex: 'action',
    fixed: 'right',
    width: 180,
    scopedSlots: {
      customRender: 'action'
    }
  }
];
